import * as React from 'react';
import { Moment } from 'moment';

import { ListingWithUserPopulated } from '@app/offer/OfferEdit/types';
import { DatePicker, TimePicker } from '../../react-common/Pickers';

type OfferIrrevocabieDateProps = {
  irrevocableDate: Date;
  onDateChange: (date: Moment, value: string) => void;
  onTimeChange: (time: Moment, value: string) => void;
  listing?: ListingWithUserPopulated;
  errorMessage?: string;
};

const OfferIrrevocabieDate: React.FunctionComponent<
  OfferIrrevocabieDateProps
> = ({
  irrevocableDate,
  onDateChange,
  onTimeChange,
  listing,
  errorMessage,
}) => (
  <>
    <h4>Irrevocability</h4>
    <div className="form-horizontal">
      <div className="form-group">
        <label className="col-sm-3 control-label" htmlFor="irrevocableDate">
          Date:
        </label>
        <div className="col-sm-9">
          <div className="date-time-container">
            <div>
              <DatePicker
                value={irrevocableDate}
                onChange={onDateChange}
                format="YYYY-MM-DD"
                variant="inline"
                inputVariant="outlined"
                autoOk
                disablePast
                {...(listing?.status === 'Coming Soon' && {
                  minDate: new Date(listing.coming_soon_date!),
                })}
              />
            </div>
          </div>
        </div>
      </div>
      {irrevocableDate && (
        <div className="form-group">
          <label className="col-sm-3 control-label" htmlFor="irrevocableTime">
            Time:
          </label>
          <div className="col-sm-9">
            <div className="date-time-container">
              <div>
                <TimePicker
                  value={irrevocableDate}
                  onChange={onTimeChange}
                  minutesStep={10}
                  variant="inline"
                  inputVariant="outlined"
                  autoOk
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {errorMessage && <label className="error">{errorMessage}</label>}
    </div>
  </>
);

export default OfferIrrevocabieDate;
